import * as angular from 'angular';
import ContractFilesController from './contract-files-controllers';
import contractService from "../../../service/contract/contract-services";

function fileModel(contract: contractService) {
    return {
        restrict: 'A',
        link: (scope: angular.IScope, element: any) => {
            element.bind('change', function() {
                scope.$apply(function() {
                    angular.forEach(element[0].files, function(file) {
                        (scope as any).registerNewFile(file);
                    });
                    element[0].value = '';
                });
            });
        }
    };
}
fileModel.$inject = ['contract'];

export default angular.module('dataforvalter.contract-files', [
    'dataforvalter.contract'
])
    .controller('ContractFilesController', ContractFilesController)
    .directive('fileModel', fileModel)
    .name;
